module.exports = __webpack_public_path__ + "static/media/file-icon.3a821d67.svg";